import React, { PureComponent } from "react";
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions/';
import ReactMoment from 'react-moment';
import moment from 'moment';
import axios from 'axios';
import cx from 'classnames';
// import Animate from 'react-move/Animate';
// import { easeExpIn, easeExpOut, easeLinear } from 'd3-ease';
import Draggable from 'react-draggable';
import { Tooltip } from 'react-tippy';
import { Grid, Column } from 'react-virtualized';
import { Helmet } from "react-helmet";
import Tabs, { Tab } from 'material-ui/Tabs';
import Switch from 'material-ui/Switch';
import FormControlLabel from 'material-ui/Form/FormControlLabel';
import RadioGroup from 'material-ui/Radio/RadioGroup';
import Radio from 'material-ui/Radio';
import Table, { TableBody, TableCell, TableHead, TableRow, TableSortLabel, TablePagination } from 'material-ui/Table';
import { withStyles } from 'material-ui/styles';
import MGrid from 'material-ui/Grid';
import Icon from '../graphics/Icon';
import Grade from '../graphics/Grade';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import _ from 'lodash';
import styled from 'styled-components';

import 'react-virtualized/styles.css';

const DetailWrapper = styled.div`
  background: #FEEDCB;
  position: fixed;
  text-align: center;
  z-index: 350;
  width: 100%;
  height: 100%;

  .icon.back {
    margin-right: 8px;
    vertical-align: middle;
  }
  .social {
    .icon {
      margin: 0 5px;
      line-height: 2.6em;
    }
    span {
      cursor: pointer;
    }
  }
  p {
    font-weight: 300;
    letter-spacing: 0.01em;
  }
`;
const BackLink = styled.div`
  font-size: 19px;
  color: #FF9700;
  cursor: pointer;
  margin: 60px 0 25px 0;
  text-align: left;
  @media (min-width: 600px) {
    margin: 50px 0 25px 0;
  }
  @media (min-width: 600px) and (min-height: 800px) {
    margin: 100px 0 25px 0;
  }
  @media (min-width: 960px) {
    margin: 50px 60px 25px 0;
  }
  @media (min-width: 960px) and (min-height: 800px) {
    margin: 120px 60px 25px 0;
  }
  @media (min-width: 1280px) {
    margin: 50px 160px 25px 0;
  }
  @media (min-width: 1280px) and (min-height: 800px) {
    margin: 140px 160px 25px 0;
  }
`;
const Container = styled.div`
  font-size: 16px;
  color: #474747;
  margin: 0 0 60px 30px;
  text-align: left;
  height: 100%;

  @media (min-width: 600px) {
    margin: 0 0 0 180px;
    // height: calc(100% - 100px);
    height: 100%;
  }
  @media (min-width: 600px) and (min-height: 800px) {
    margin: 0 0 0 180px;
    // height: calc(100% - 150px);
    height: 100%;
  }
  @media (min-width: 960px) {
    margin: 0 0 0 160px;
    // height: calc(100% - 100px);
    height: calc(100% - 62px);
  }
  @media (min-width: 960px) and (min-height: 800px) {
    margin: 0 0 0 200px;
    // height: calc(100% - 170px);
    height: calc(100% - 62px);
  }
  @media (min-width: 1280px) {
    margin: 0 0 0 200px;
    // height: calc(100% - 100px);
    height: calc(100% - 62px);
  }
  @media (min-width: 1280px) and (min-height: 800px) {
    margin: 0 0 0 200px;
    // height: calc(100% - 190px);
    height: calc(100% - 62px);
  }
  .slide {
    width: 100%;
    height: 350px;
    width: 100%;
    background-position: center;
    background-size: cover;
  }
`;
const Content = styled.div`
  padding: 0 30px 30px 0;
  @media (min-width: 960px) {
    padding: 0 40px 30px 0;
  }
  @media (min-width: 960px) {
    padding: 0 60px 40px 0;
  }
  @media (min-width: 1280px) {
    padding: 0 100px 40px 0;
  }
  @media (min-width: 1920px) {
    padding: 0 200px 50px 0;
  }
`;
const Title = styled.div`
  font-size: 35px;
  color: #0066FF;
  line-height: 1.1em;
  font-weight: 700;

  @media (min-width: 600px) {
    font-size: 38px;
  }
  @media (min-width: 800px) {
    font-size: 42px;
  }
  @media (min-width: 1000px) {
    font-size: 48px;
  }
  @media (min-width: 1280px) {
    font-size: 52px;
  }
  @media (min-width: 1920px) {
    font-size: 60px;
  }
`;
const SubTitle = styled.div`
  font-size: 32px;
  color: #0066FF;
  margin-bottom: 25px;
  font-weight: 300;

  @media (min-width: 600px) {
    font-size: 36px;
  }
  @media (min-width: 960px) {
    font-size: 40px;
  }
  @media (min-width: 1280px) {
    font-size: 42px;
  }
  @media (min-width: 1920px) {
    font-size: 48px;
  }
`;
const Stat = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  font-weight: 400;
  margin-bottom: 10px;

  @media (min-width: 600px) {
    padding: 12px 15px 8px 15px;
  }
  @media (min-width: 1280px) {
    padding: 15px 20px 10px 20px;
  }
  .label {
    font-size: 16px;
    color: #666;
    white-space: nowrap;
  }
  .label2 {
    font-size: 13px;
    color: #666;
    white-space: nowrap;
  }
  .date {
    font-size: 10px;
    color: #666;
    margin-top: -12px;
    line-height: 1.3em;
    text-align: right;

    @media (min-width: 1280px) {
      margin-top: 0;
    }
  }
  .grade {
    display: inline-block;
    vertical-align: bottom;
    margin-right: 10px;
    margin-top: 10px;
    @media (min-width: 1280px) {
      margin-left: 5px;
    }
  }
  .gradeText {
    font-size: 36px;
    color: #333;
  }
  .gGroup {
    white-space: nowrap;
  }
`;
const Alert = styled.div`
  margin: 10px 0;
  font-size: 14px;
`;
const AlertType = styled.div`
  display: flex;
  align-items: center;

  .gradeText {
    @media (min-width: 600px) {
      font-size: 36px;
    }
    @media (min-width: 960px) {
      font-size: 32px;
    }
    @media (min-width: 1280px) {
      font-size: 36px;
    }
  }
`;
const Description = styled.div`
  margin-top: 40px;
  color: #474747;
  font-size: 16px;
`;
const Carousel = styled.div`
  margin-top: 20px;
  @media (min-width: 960px) {
    margin-top: 0;
  }
`;
const Historical = styled.div`
  margin: 0 0 40px 0;
  h3 {
    margin: 40px 0 30px 0;
    color: #0066FF;
    font-size: 24px;
  }
`;
const DataTable = styled.div`
  margin: 0 0 40px 0;
  .grade {
    text-align: center;
  }
  .loading {
    border: none;
  }
`;
const TabArea = styled.div`
  height: 40px;
  position: relative;
  width: 100%;
  z-index: 5;
  top: 0;
  padding-bottom: 10px;
`;
const TabContainer = styled.div`
  width: 340px;
  height: 40px;
`;
const ChartContainer = styled.div`
  width: 100%;
  height: 200px;
  background: #fff;
  position: relative;
  cursor: ${props => props.annual ? 'default' : 'ew-resize'};
  overflow: hidden;

  .gradeItems {
    display: flex;
    flexWrap: nowrap;
    top: 0;
    right: 0;
    height: 100%;
    transition: all .5s linear;
    transform: translate3d(0, 0, 0);
    transform-style: preserve-3d;
    backface-visibility: hidden;
  }
`;
const GradeItem = styled.div`
  outline: 1px solid #d4d4d4;
  transition: width 0.25s ease-in-out;
  z-index: 10;

  &:hover {
    opacity: 0.9;
  }
  .tt {
    display: block !important;
    width: 100%;
    height: 100%;
  }
  .inner {
    color: #fff;
    font-size: 10px;
    width: 100%;
    height: 100%;
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    flex: 1;
    flex-direction: column;

    svg {
      height: 50px;
    }
    &.ns { 
        color: #474747;
    }
  }
  .letter {
    font-weight: 900;
  }
  &.ns { 
    background: #fff; 
    color: #474747; 

    .letter { font-weight: 400; }
  }
  &.a, &.good { 
    background: #0066FF; 
  }
  &.b { 
    background: #40B4E5; 
  }
  &.c { 
    background: #FFD400; 
  }
  &.d { 
    background: #FF9700; 
  }
  &.f, &.poor { 
    background: #F26859; 
  }
  &.active {
    background: #333;

    .__react_component_tooltip {
      display: flex;
    }
  }
`;
const Toggle = styled.div`
  font-size: 12px;
  padding-left: 10px;
`;
const ZoomButtons = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  margin-right: 5px;

  .icon {
    font-weight: 900;
    font-size: 18px;
    color: #fff;
    display: inline-block;
    cursor: pointer;
    padding: 6px;

    &:hover {
      color: #FFD400;
    }
    &.disabled {
      cursor: default;
      color: #ccc;

      &:hover { color: #d4d4d4; }
    }
  }
`;
const ArrowPrev = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 50;
  cursor: pointer;
`;
const ArrowNext = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 50;
  cursor: pointer;
`;
const Ad = styled.div`
  background-size: cover;
  position: relative;
  height: 350px;
`;
const AdLogo = styled.div`
  width: 150px;
  margin-bottom: 20px;

  @media (min-width: 960px) {
    width: 40%;
  }
`;
const AdButton = styled.a`
  background: #fff;
  color: #0066ff;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 16px;
  display: inline-block;
`;
const AdText = styled.div`
  color: #fff;
  font-weight: 600;
  font-size: 21px;
  margin-bottom: 20px;
`;
const AdWrap = styled.div`
  position: absolute;
  top: 0;
  margin: 20px 10%;
  width: 80%;
  height: calc(100% - 40px);
`;
const DateRange = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  font-size: 12px;
`;
const StartDate = styled.div`
  width: 50%;
  padding: 5px;
`;
const EndDate = styled.div`
  width: 50%;
  padding: 5px;
  text-align: right;
`;
const SlideWrap = styled.div`
  width: 100%;
  height: 100%;
`;

const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

class Detail extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      gradeType: 0,
      gType: 'nowcast',
      dryDefault: true,
      annualType: 'summer',
      nowcastGrades: [],
      nowcastGrades2: [],
      weeklyGrades: [],
      annualGrades: [],
      dryGrades: [],
      wetGrades: [],
      numGrades: 0,
      countyContact: '',
      countyPhone: '',
      countyUrl: '',
      countyNotes: '',
      posX: 0,
      gradeWidth: 50,
      showPrevArrow: true,
      sortBy: 'date',
      sortDirection: 'desc',
      sortedList: [],
      page: 0,
      rowsPerPage: 10
    };
    this.onResize = this.onResize.bind(this);
    this._headerRenderer = this._headerRenderer.bind(this);
    this._cellRenderer = this._cellRenderer.bind(this);
  }
  chart = (ref) => this.containerNode = ref;
  gridRef = (ref) => this.gridNode = ref;

  componentWillMount() {
    const { detail } = this.props;
    this.fetchNowCast(parseInt(detail.id));
    this.fetchCountyInfo();
  }
  componentDidMount() {
    const { sortBy, sortDirection } = this.state;
    document.addEventListener('keydown', this.handleKeyEvent);
    document.addEventListener('keyup', this.handleStopArrows);
    window.addEventListener('resize', this.onResize, false);
    if (this.containerNode) {
      this.setState({ chartWidth: this.containerNode.clientWidth });
    }
    // console.log(this.props.detail);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }
  onResize() {
    this.setState({ chartWidth: this.containerNode.clientWidth });
  }
  fetchNowCast(id) {
    // console.log('fetchNowCast');
    var _this = this;
    axios('/nowcast/' + id)
      .then(response => {
        return response.data;
      })
      .then(data => {
        var records = [];
        data.hits.hits.forEach(record => {
          records.push(record._source);
        });
        return records;
      })
      .then(grades => {
        grades.sort((a, b) => {
          a = new Date(a.NowcastDate);
          b = new Date(b.NowcastDate);
          return a - b;
        });
        return grades;
      })
      .then(grades => {
        var nowcastGrades = [];
        grades.forEach(g => {
          var obj = {
            date: new Date(g.NowcastDate),
            grade: g.NowcastPassFlag === '1' ? 'Good' : 'Poor'
          }
          nowcastGrades.push(obj);
        });
        _this.setState({ nowcastGrades: [...nowcastGrades] });
        _this.setState({ nowcastGrades2: [...nowcastGrades.reverse()] });
        _this.fetchGrades(id);
      })
      .catch(function (err) {
        console.warn(err);
      });
  }
  fetchGrades = id => {
    var _this = this;
    axios('/grades/' + id)
      .then(response => {
        return response.data;
      })
      .then(data => {
        var records = [];
        data.hits.hits.forEach(record => {
          records.push(record._source);
        });
        return records;
      })
      .then(grades => {
        grades.sort((a, b) => {
          a = new Date(a.GradeDate);
          b = new Date(b.GradeDate);
          return a - b;
        });
        // _this.getAllData();
        return grades;
      })
      .then(grades => {
        var dryGrades = [], wetGrades = [], allGrades = [];
        grades.forEach(g => {
          var obj = {
            ...g,
            date: new Date(g.GradeDate)
          }
          allGrades.push(obj);

          var dryObj = {
            date: g.GradeDate,
            grade: g.DryGrade
          }
          dryGrades.push(dryObj);

          var wetObj = {
            date: g.GradeDate,
            grade: g.WetGrade
          }
          wetGrades.push(wetObj);
        });
        // console.log(dryGrades);
        _this.setState({ dryGrades: [...dryGrades] });
        _this.setState({ wetGrades: [...wetGrades] });
        _this.setState({ weeklyGrades: [...allGrades.reverse()] });
        _this.fetchAnnualGrades(id);
      })
      .catch(function (err) {
        console.warn(err);
      });
  }
  fetchAnnualGrades = id => {
    var _this = this;
    axios('/annual_grades/' + id)
      .then(response => {
        return response.data;
      })
      .then(data => {
        var records = [];
        data.hits.hits.forEach(record => {
          records.push(record._source);
        });
        return records;
      })
      .then(grades => {
        grades.sort((a, b) => {
          a = a.Year;
          b = b.Year;
          return a - b;
        });
        return grades;
      })
      .then(grades => {
        var summerDry = [], winterDry = [], annualWet = [];
        grades.forEach(g => {
          var dry1Obj = {
            date: g.Year,
            grade: g.SummerDry
          }
          summerDry.push(dry1Obj);

          var dry2Obj = {
            date: g.Year,
            grade: g.WinterDry
          }
          winterDry.push(dry2Obj);

          var wetObj = {
            date: g.Year,
            grade: g.AnnualWet
          }
          annualWet.push(wetObj);
        });

        _this.setState({ summerDry: [...summerDry] });
        _this.setState({ winterDry: [...winterDry] });
        _this.setState({ annualWet: [...annualWet] });
        _this.setState({ annualGrades: [...grades.reverse()] });
        _this.setDefaultChart();
      })
      .catch(function (err) {
        console.warn(err);
      });
  }
  fetchCountyInfo() {
    const { detail } = this.props;
    var _this = this;
    axios('/counties/' + detail.countyId)
      .then(function (response) {
        return response.data._source;
      })
      .then(function (data) {
        // console.log(data);
        if (data.hasOwnProperty('maName')) _this.setState({ countyContact: data.maName });
        if (data.hasOwnProperty('maPhone')) _this.setState({ countyPhone: data.maPhone });
        if (data.hasOwnProperty('maWebsiteUrl')) _this.setState({ countyUrl: data.maWebsiteUrl });
        if (data.hasOwnProperty('notes')) _this.setState({ countyNotes: data.notes });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  setData = (type) => {
    // console.log('setData');
    const { gType, dryDefault, nowcastGrades, dryGrades, wetGrades, weeklyGrades, annualGrades, summerDry, winterDry, annualWet, annualType } = this.state;
    var data = [];
    var g = type ? type : gType;
    // console.log('g: ', g);
    switch (g) {
      default:
      case 'nowcast':
        data = nowcastGrades;
        break;
      case 'weekly':
        if (!!dryDefault) data = dryGrades;
        else data = wetGrades;
        break;
      case 'weeklyDry':
        data = dryGrades;
        break;
      case 'weeklyWet':
        data = wetGrades;
        break;
      case 'annual':
        if (annualType === 'summer') data = summerDry;
        else if (annualType === 'winter') data = winterDry;
        else data = annualWet;
        break;
      case 'summer':
        data = summerDry;
        break;
      case 'winter':
        data = winterDry;
        break;
      case 'wet':
        data = annualWet;
        break;
    }
    this.setState({ data: data });
    this.setState({ numGrades: data.length });
    this.gridNode.forceUpdate();
  }
  setDefaultChart = (tab) => {
    const { nowcastGrades, gradeType } = this.state;
    var t = tab !== undefined ? tab : gradeType;
    var g;
    switch (t) {
      default:
      case 0:
        if (nowcastGrades.length > 0) g = 'nowcast';
        else g = 'weekly';
        break;
      case 1:
        if (nowcastGrades.length > 0) g = 'weekly';
        else g = 'annual';
        break;
      case 2:
        if (nowcastGrades.length > 0) g = 'annual';
        break;
    }
    this.setState({ gType: g, sortedList: this._sortList('date', 'desc', g) });
    this.setData(g);
  }
  setChartWidth = () => {
    // console.log('setChartWidth');
    const { chartWidth } = this.state;
    var theChart = document.getElementById('theChart');
    var gradesNodes = theChart.querySelector('.ReactVirtualized__Grid__innerScrollContainer');
    if (gradesNodes) {
      // console.log('gradesNodes: ', gradesNodes.offsetWidth);
      this.setState({ chartGradesWidth: gradesNodes.offsetWidth });
      if (gradesNodes.offsetWidth > chartWidth) {
        this.setState({ showPrevArrow: true });
      }
    }
  }
  handleAdClick = () => {
    const { ad } = this.props;
    this.props.onClickAd();
    window.open(ad.url.indexOf('http') === -1 ? 'http://' + ad.url : ad.url, '_blank');
  }
  handleDetailClose = () => {
    // console.log('handleDetailClose');
    const { wW, wH, onShowDetail } = this.props;
    onShowDetail(false);
    if (wH > wW && wW < 600) {
      window.setTimeout(function () {
        window.scrollTo(0, document.body.scrollHeight);
      }, 50);
    }
  }
  handleChangePage = (event, page) => {
    this.setState({ page });
  }
  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  }
  handleTabChange = (event, tab) => {
    const { nowcastGrades } = this.state;
    this.setState({ gradeType: tab, sortBy: 'date', sortDirection: 'desc' });
    this.setDefaultChart(tab);
    if (nowcastGrades.length > 0 && tab === 2) {
      this.setState({ posX: 0, showPrevArrow: false });
    } else if (nowcastGrades.length === 0 && tab === 1) {
      this.setState({ posX: 0, showPrevArrow: false });
    } else {
      this.setState({ showPrevArrow: true });
    }
  }
  handleTypeSelect = event => {
    this.setState({ annualType: event.target.value });
    this.setData(event.target.value);
  }
  handleDryOrWet = event => {
    // console.log('handleDryOrWet');
    this.setState({ dryDefault: !this.state.dryDefault });
    var state = this.state.dryDefault ? 'weeklyWet' : 'weeklyDry';
    this.setData(state);
  }
  handleMouseMove = (e) => {
    // console.log('handleMouseMove');
    var el = document.getElementById('theChart');
    var rect = el.getBoundingClientRect(),
      body = document.body,
      docEl = document.documentElement,
      scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft,
      clientLeft = docEl.clientLeft || body.clientLeft || 0,
      left = rect.left + scrollLeft - clientLeft,
      moveX = e.clientX - Math.round(left);
    this.setState({ mouseX: moveX });
  }
  handleMouseTracking = (e) => {
    window.addEventListener("mousemove", this.handleMouseMove);
  }
  stopMouseTracking = (e) => {
    window.removeEventListener("mousemove", this.handleMouseMove);
  }
  showPrev = () => {
    // console.log('move prev');
    const { chartWidth, chartGradesWidth, gradeWidth } = this.state;
    var theChart = document.getElementById('theChart');
    var gradesNodes = theChart.querySelector('.ReactVirtualized__Grid__innerScrollContainer');
    var gradesWidth = chartGradesWidth ? chartGradesWidth - chartWidth : gradesNodes.offsetWidth - chartWidth;
    this.setState(prevState => ({
      posX: prevState.posX + gradeWidth <= gradesWidth ? prevState.posX + gradeWidth : gradesWidth
    }));
    this.goBackwards = requestAnimationFrame(this.showPrev);
  }
  showNext = () => {
    // console.log('move next');
    const { gradeWidth } = this.state;
    let cW = gradeWidth * -1;
    this.setState(prevState => ({
      posX: prevState.posX + cW > 0 ? prevState.posX + cW : 0
    }));
    this.goForwards = requestAnimationFrame(this.showNext);
  }
  handlePrevArrow = () => {
    this.goBackwards = requestAnimationFrame(this.showPrev);
  }
  handleNextArrow = () => {
    this.goForwards = requestAnimationFrame(this.showNext);
  }
  handleStopArrows = () => {
    cancelAnimationFrame(this.goBackwards);
    cancelAnimationFrame(this.goForwards);
  }
  handleKeyEvent = (e) => {
    // console.log('handleKeyEvent');
    if (e.dispatchConfig) e.preventDefault();
    const { gradeWidth, gType } = this.state;
    if (e.deltaY) {
      var factor = e.deltaY * 0.1;
    } else if (e.keyCode) {
      var factor = e.keyCode === 40 ? -2 : e.keyCode === 38 ? 2 : 0;
      if (e.keyCode === 37) requestAnimationFrame(this.showPrev);
      else if (e.keyCode === 39) requestAnimationFrame(this.showNext);
    }
    var newWidth = gradeWidth + factor;
    if (factor && gType !== 'annual') this.setState({ gradeWidth: newWidth < 15 ? 15 : newWidth > 50 ? 50 : newWidth });
  }
  handleStop = (e) => {
    // console.log('handleStop');
    var el = document.querySelector('.gradeItems');
    var style = el.style.transform;
    var matrix = style.replace(/[^0-9\-.,]/g, '').split(',');
    this.setState({ posX: parseInt(matrix[0]) });
  }
  handleZoomIn = (e) => {
    const { gradeWidth } = this.state;
    if (gradeWidth > 15) this.plusClicked = requestAnimationFrame(this.zoomIn);
  }
  zoomIn = () => {
    const { gradeWidth, gType } = this.state;
    var factor = 3;
    var newWidth = gradeWidth - factor;
    if (factor && gType !== 'annual') this.setState({ gradeWidth: newWidth < 15 ? 15 : newWidth > 50 ? 50 : newWidth });
    if (gradeWidth > 15) this.plusClicked = requestAnimationFrame(this.zoomIn);
  }
  handleZoomOut = (e) => {
    const { gradeWidth } = this.state;
    if (gradeWidth < 50) this.minusClicked = requestAnimationFrame(this.zoomOut);
  }
  zoomOut = () => {
    const { gradeWidth, gType } = this.state;
    var factor = 3;
    var newWidth = gradeWidth + factor;
    if (factor && gType !== 'annual') this.setState({ gradeWidth: newWidth < 15 ? 15 : newWidth > 50 ? 50 : newWidth });
    if (gradeWidth < 50) this.minusClicked = requestAnimationFrame(this.zoomOut);
  }
  handleStopZoom = (e) => {
    cancelAnimationFrame(this.plusClicked);
    cancelAnimationFrame(this.minusClicked);
  }
  renderNowcast = () => {
    const { detail } = this.props;
    var nowcast, nowcast_icon, nowcast_date;
    var timeframe = moment().subtract(1, 'days');
    nowcast_date = detail.nowcast_date;
    if (detail.currentAlerts.length === 0 && detail.hasOwnProperty('nowcast_pass_flag') && moment(nowcast_date).add(7, 'hours').isSameOrAfter(timeframe)) {
      if (parseInt(detail.nowcast_pass_flag) > 0) {
        nowcast = 'Good';
        nowcast_icon = 'good';
      } else {
        nowcast = 'Poor';
        nowcast_icon = 'poor';
      }

      var nDate = moment(nowcast_date).add(7, 'hours').fromNow();
      return (
        <MGrid container spacing={24} style={{ marginBottom: '3px' }}>
          <MGrid item xs={12}>
            <Stat>
              <MGrid container spacing={24} alignItems="baseline">
                <MGrid className="label" item sm={6}>NowCast</MGrid>
                <MGrid className="date right-md" item sm={6}>{nowcast_date ? nDate : ''}</MGrid>
              </MGrid>
              <Grade grade={nowcast_icon} /> <span className="gradeText">{nowcast}</span>
            </Stat>
          </MGrid>
        </MGrid>
      );
    } else {
      return null;
    } 
  }
  renderAlert = () => {
    const { detail } = this.props;
    var alerts = [];
    if (detail.currentAlerts.length > 0) {
      return detail.currentAlerts.map((alert, i) => {
        return (
          <MGrid key={i} container spacing={24} style={{ marginBottom: '3px' }}>
            <MGrid item xs={12}>
              <Stat style={{ marginBottom: '3px' }}>
                <MGrid container spacing={24} alignItems="baseline">
                  <MGrid className="label" item xs={6}>Alert</MGrid>
                  <MGrid className="date right-md" item sm={6}>{moment(alert.ActivityStartDate).endOf('day').fromNow()}</MGrid>
                </MGrid>
                <AlertType><Grade grade={alert.ActivityType} /> <span className="gradeText">{alert.ActivityType}</span></AlertType>
                <Alert>{alert.Comments}</Alert>
              </Stat>
            </MGrid>
          </MGrid>
        );
      });
    } else {
      return null;
    }
  }
  renderAnnuals = () => {
    const { detail } = this.props;
    var d = new Date();

    if (detail.hasOwnProperty('annual_year') && detail.annual_year == d.getFullYear()) {
      return (
        <MGrid container spacing={24} style={{ marginBottom: '3px' }}>
          <MGrid item xs={12}>
            <Stat>
              <div className="label" style={{ marginBottom: 5 }}>2018 Annual Grades</div>
              <MGrid container spacing={16}>
                <MGrid item xs={4}>
                  <div className="label2">Summer Dry</div>
                  <div className="gGroup"><Grade grade={detail.annual_summer_dry} /> <span className="gradeText">{detail.annual_summer_dry}</span></div>
                </MGrid>
                <MGrid item xs={4}>
                  <div className="label2">Annual Wet</div>
                  <div className="gGroup"><Grade grade={detail.annual_year_wet} /> <span className="gradeText">{detail.annual_year_wet}</span></div>
                </MGrid>
                <MGrid item xs={4}>
                  <div className="label2">Winter Dry</div>
                  <div className="gGroup"><Grade grade={detail.annual_winter_dry} /> <span className="gradeText">{detail.annual_winter_dry}</span></div>
                </MGrid>
              </MGrid>
            </Stat>
          </MGrid>
        </MGrid>
      );
    } else {
      return null;
    }
  }
  openWindow = (network) => {
    const { detail } = this.props;
    var getUrl = window.location, title, twitterText, fbText, googleText;
    var base = process.env.REACT_APP_PUBLIC_URL;
    var url = process.env.REACT_APP_PUBLIC_URL + getUrl.pathname;
    var fbID = process.env.REACT_APP_FACEBOOK_APP_ID;
    var hashtag = 'HealTheBay';
    if (detail.name1) {
      twitterText = 'See the latest @beachreportcard water quality grades for ' + detail.name1 + '.';
      title = 'Beach Report Card: ' + detail.name1;
      fbText = 'See the latest water quality grades for ' + detail.name1 + '. #HealTheBay';
      googleText = 'See the latest Beach Report Card water quality grades for ' + detail.name1 + '. #HealTheBay';
    } else {
      twitterText = 'See the latest @beachreportcard water quality grades for ' + detail.title + '.';
      title = 'Beach Report Card: ' + detail.title;
      fbText = 'See the latest water quality grades for ' + detail.title + '. #HealTheBay';
      googleText = 'See the latest Beach Report Card water quality grades for ' + detail.title + '. #HealTheBay';
    }
    // https://www.facebook.com/dialog/share?app_id=undefined&display=popup&quote=See%20the%20latest%20water%20quality%20grades%20for%20Will%20Rogers%20State%20Beach.%20#HealTheBay&href=https://brc-front.herokuapp.com&redirect_uri=https://brc-front.herokuapp.com/34.01276883333337/-118.50285500000001/13
    const link = (n) => ({
      'twitter': encodeURI('https://twitter.com/intent/tweet?url=' + url + '&text=' + twitterText + '&hashtags=' + hashtag),
      'gplus': encodeURI('https://plus.google.com/share?url=' + url + '&text=' + googleText + '&hl=en-US'),
      'facebook': encodeURI('https://www.facebook.com/dialog/share?app_id=' + fbID + '&display=popup&quote=' + fbText + '&href=' + base + '&redirect_uri=' + url)
    })[n];
    window.open(link(network), '_blank', "toolbar=0,status=0,width=700,height=500");
  }
  renderCountyInfo() {
    const { detail } = this.props;
    const { countyContact, countyPhone, countyUrl, countyNotes } = this.state;
    if (countyNotes || countyContact) {
      var contactLink = countyUrl.indexOf('http') === -1 ? 'http://' + countyUrl : countyUrl;
      return (
        <MGrid container spacing={0}>
          <MGrid item xs={12} md={8} lg={6}>
            <h3>Monitoring Agency Contact Info</h3>
            <p>{countyNotes}</p>
            <div><strong>Contact</strong></div>
            <div>{countyContact}</div>
            <div>{countyPhone}</div>
            <a href={contactLink} target="_blank">Website</a>
          </MGrid>
        </MGrid>
      );
    }
  }
  renderTabs() {
    const { gradeType, nowcastGrades } = this.state;
    return (
      <TabArea>
        <TabContainer>
          <Tabs value={gradeType} onChange={this.handleTabChange} indicatorColor="primary" textColor="primary">
            {nowcastGrades.length > 0 ? <Tab key="NowCast" style={{ minWidth: 0 }} label="NowCast" /> : null}
            <Tab key="Weekly" style={{ minWidth: 0 }} label="Weekly Grades" />
            <Tab key="Annual" style={{ minWidth: 0 }} label="Annual Grades" />
          </Tabs>
        </TabContainer>
      </TabArea>
    );
  }
  renderHeaderCells() {
    const { gType, sortBy, sortDirection } = this.state;
    const labels = {
      nowcast: [
        { id: 'grade', label: 'NowCast' }
      ],
      weekly: [
        { id: 'DryGrade', label: 'Dry Grade' },
        { id: 'WetGrade', label: 'Wet Grade' }
      ],
      annual: [
        { id: 'SummerDry', label: 'Summer Dry' },
        { id: 'WinterDry', label: 'Winter Dry' },
        { id: 'AnnualWet', label: 'Annual Wet' }
      ],
    }
    return labels[gType].map(label => {
      return (
        <TableCell
          style={{ position: 'sticky', top: 0 }}
          key={label.id}
          sortDirection={sortBy === label.id ? sortDirection : false}
        >
          <TableSortLabel
            active={sortBy === label.id}
            direction={sortDirection}
            onClick={this._sort(label.id)}
          >
            {label.label}
          </TableSortLabel>
        </TableCell>
      );
    });
  }
  renderTableCells = () => {
    // console.log('renderTableCells');
    const { sortBy, sortDirection, gType, sortedList, rowsPerPage, page } = this.state;
    // this._sort(sortBy, sortDirection, gType)();
    // console.log('gType: ', gType);
    // console.log('sortedList: ', sortedList);
    if (sortedList.length > 0) {
      return sortedList
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((n, i) => {
        switch (gType) {
          case 'nowcast':
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={i}
              >
                <TableCell sortDirection={sortBy === 'date' ? sortDirection : false}>{moment(n.date).format('MMM D YYYY')}</TableCell>
                <TableCell sortDirection={sortBy === 'grade' ? sortDirection : false}>{n.grade}</TableCell>
              </TableRow>
            );
          case 'weekly':
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={i}
              >
                <TableCell sortDirection={sortBy === 'date' ? sortDirection : false}>{moment(n.GradeDate).format('MMM D YYYY')}</TableCell>
                <TableCell sortDirection={sortBy === 'DryGrade' ? sortDirection : false}>{n.DryGrade}</TableCell>
                <TableCell sortDirection={sortBy === 'WetGrade' ? sortDirection : false}>{n.WetGrade}</TableCell>
              </TableRow>
            );
          case 'annual':
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={i}
              >
                <TableCell sortDirection={sortBy === 'date' ? sortDirection : false}>{n.Year}</TableCell>
                <TableCell sortDirection={sortBy === 'SummerDry' ? sortDirection : false}>{n.SummerDry}</TableCell>
                <TableCell sortDirection={sortBy === 'WinterDry' ? sortDirection : false}>{n.WinterDry}</TableCell>
                <TableCell sortDirection={sortBy === 'AnnualWet' ? sortDirection : false}>{n.AnnualWet}</TableCell>
              </TableRow>
            );
        }
      });
    } else {
      return (
        <TableRow><TableCell className="loading">Loading...</TableCell></TableRow>
      );
    }
  }
  renderEmptyRows = () => {
    const { sortedList, rowsPerPage, page } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, sortedList.length - page * rowsPerPage);
    
    if (emptyRows > 0) {
      return (
        <TableRow>
          <TableCell className="loading" />
        </TableRow>
      );
    }
  }
  _headerRenderer({ columnData, dataKey, disableSort, label, sortBy, sortDirection }) {
    const showSortIndicator = sortBy === dataKey;
    const children = [
      <span 
        key="label"
        className={!!showSortIndicator ? "ReactVirtualized__Table__header active" : "ReactVirtualized__Table__header"}
        title={label}>{label}</span>,
      <svg key="s" width={18} height={18} viewBox="0 0 24 24">
        {(sortDirection === 'ASC' && !!showSortIndicator) ? (
          <path d="M7 14l5-5 5 5z" />
        ) : (
            (sortDirection === 'desc' && !!showSortIndicator) ? <path d="M7 10l5 5 5-5z" /> : null
          )}
      </svg>
    ];
    return children;
  }
  _cellRenderer({ columnIndex, key, rowIndex, style }) {
    const g = this._getDatum(columnIndex);
    // console.log(g);
    var letter;
    switch (g.grade) {
      case 'A+':
      case 'A':
      case 'A-':
        letter = 'a';
        break;
      case 'B+':
      case 'B':
      case 'B-':
        letter = 'b';
        break;
      case 'C+':
      case 'C':
      case 'C-':
        letter = 'c';
        break;
      case 'D':
        letter = 'd';
        break;
      case 'F':
        letter = 'f';
        break;
      case 'Poor':
      case 'Good':
      case 'ns':
        letter = g.grade.toLowerCase();
        break;
    }
    const TooltipContent = (
      <div className={cx(letter, {
        'tooltip': true
      })}
        style={style.width > 30 ? { opacity: 0 } : { opacity: 1 }}>
        <div className="letter">{g.grade}</div>
        {typeof g.date !== 'number' ? <div style={{ whiteSpace: 'nowrap' }}>{moment(g.date).format('MMM D')}</div> : null}
        <div style={{ fontSize: (typeof g.date === 'number') ? 10 : 12 }}>{g.date.length === 4 ? g.date : moment(g.date).format('YYYY')}</div>
      </div>
    );
    return (
      <GradeItem key={key}
        className={cx(letter, {
          'gradeItem': true
        })}
        style={{ width: style.width }}>
        <Tooltip
          useContext
          arrow={false}
          duration={100}
          followCursor={true}
          html={TooltipContent}
        >
          <div
            className={cx(letter, {
              'inner': true
            })}
            style={{
              opacity: style.width > 30 ? 1 : 0,
              fontSize: style.width > 50 ? 16 : style.width < 40 ? 10 : 12
            }}>
            {style.width > 65 ? <Grade grade={g.grade} /> : <div className="letter">{g.grade}</div>}
            {typeof g.date !== 'number' ? <div style={{ whiteSpace: 'nowrap' }}>{moment(g.date).format('MMM D')}</div> : null}
            <div style={{ fontSize: (typeof g.date === 'number') ? 12 : 10 }}>{(typeof g.date === 'number') ? g.date : moment(g.date).format('YYYY')}</div>
          </div>
        </Tooltip>
      </GradeItem>
    );
  }
  _getTableData(tab) {
    // console.log('_getTableData');
    // console.log(tab);
    const { gType, nowcastGrades2, weeklyGrades, annualGrades } = this.state;
    // console.log('nowcastGrades: ', nowcastGrades);
    // console.log('weeklyGrades: ', weeklyGrades);
    // console.log('annualGrades: ', annualGrades);
    var t = tab ? tab : gType;
    // console.log('t: ', t);
    switch (t) {
      case 'nowcast':
        return nowcastGrades2;
      case 'weekly':
      case 'DryGrade':
      case 'WetGrade':
        return weeklyGrades;
      case 'annual':
      case 'SummerDry':
      case 'WinterDry':
      case 'AnnualWet':
        return annualGrades;
    }
  }
  _getDatum = (index) => {
    const { data } = this.state;
    if (data) {
      return data[index];
    }
  }
  _sort = (by) => event => {
    // console.log('_sort');
    // console.log('by: ', by);
    const { gType, sortBy, sortDirection } = this.state;
    const defaultSort = by !== 'date' ? 'asc' : 'desc';
    const direction = by !== sortBy ? defaultSort : sortDirection === 'desc' ? 'asc' : 'desc';
    const sortedList = this._sortList(by, direction, gType);
    this.setState({ 
      sortDirection: direction,
      sortBy: by,
      sortedList
    });
    // this.gridNode.forceUpdate();
  }
  _sortList = (sortBy, sortDirection, type) => {
    // console.log('_sortList');
    const data = this._getTableData(type);
    // console.log(data);
    // console.log('sortBy: ', sortBy);
    // console.log('sortDirection: ', sortDirection);
    var sortedList;
    if (sortBy === 'date') {
      // console.log('date');
      sortedList = _.orderBy(data, [sortBy], [sortDirection]);
    } else {
      //  console.log('else');
      // sortedList = _.orderBy(data, [sortBy, 'date'], [dir, 'desc']);
      sortedList = _.orderBy(data, [function (g) {
        var order = {
          'A+': 0, 'A': 1, 'A-': 2, 'B+': 3, 'B': 4, 'B-': 5, 'C+': 6, 'C': 7, 'C-': 8, 'D': 9, 'F': 10, 'Good': 12, 'Poor': 13, 'ns': 11
        };
        var grade = g[sortBy];
        return order[grade];
      }, 'date'], [sortDirection, 'desc']);
    }
    // console.log(sortedList);
    return sortedList;
  }
  renderDateRange = () => {
    const { data, chartWidth, gradeWidth, posX, gType } = this.state;
    
    var numHidden = Math.abs(posX / gradeWidth);
    // console.log('posX: ', posX);
    // console.log('numHidden: ', numHidden);
    var numTotalVisible = chartWidth / gradeWidth;
    // console.log('numTotalVisible: ', numTotalVisible);
    var totalFraction = numTotalVisible - Math.floor(numTotalVisible);
    // console.log('totalFraction: ', totalFraction);
    var endFraction = (1 - (posX % gradeWidth) / gradeWidth);
    var balance = endFraction > totalFraction ? endFraction - totalFraction : endFraction;
    // console.log('balance: ', balance);
    var startFraction = Math.abs(totalFraction - balance);
    // console.log('startFraction: ', startFraction);
    // console.log('endFraction: ', endFraction);
    var startNumHidden = startFraction > 0.5 ? Math.ceil(numHidden) : Math.floor(numHidden);
    var endNumHidden = endFraction > 0.5 ? Math.floor(numHidden) : Math.ceil(numHidden);
    // console.log('startNumHidden: ', startNumHidden);
    // console.log('endNumHidden: ', endNumHidden);
    var offset = 0, startDate = [], endDate = [];
    if (posX > 0) offset = 1;
    if (data) {
      var list = [...data];
      list.reverse();
      startDate = list.filter((item, index) => {
        return index === Math.floor(numTotalVisible) + startNumHidden;
      });
      if (posX > (gradeWidth * 0.5)) {
        endDate = list.filter((item, index) => {
          return index === endNumHidden;
        });
      } else {
        endDate[0] = list[0];
      }
    }
    if (startDate[0]) {
      // console.log('startDate: ', startDate[0]);
      var start = startDate[0].date ? moment(startDate[0].date).format('MMM D YYYY') :
        startDate[0].GradeDate ? moment(startDate[0].GradeDate).format('MMM D YYYY') : startDate[0].Year;
    }
    if (endDate[0]) {
      var end = endDate[0].date ? moment(endDate[0].date).format('MMM D YYYY') :
        endDate[0].GradeDate ? moment(endDate[0].GradeDate).format('MMM D YYYY') : endDate[0].Year;
    }
    if (gType === 'annual') {
      return null;
    } else {
      return (
        <DateRange>
          <StartDate>{start}</StartDate>
          <EndDate>{end}</EndDate>
        </DateRange>
      );
    }
  }
  render() {
    const { detail, ad, classes } = this.props;
    const { wW, gType, dryDefault, annualType, gradeWidth, chartWidth, posX, chartGradesWidth, numGrades, sortBy, sortDirection, sortedList, showPrevArrow, page, rowsPerPage } = this.state;
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    // console.log('chartGradesWidth: ', chartGradesWidth);
    // console.log('chartWidth: ', chartWidth);
    // console.log('posX: ', posX);
    var detailImages = [...detail.images];
    if (ad && ad.hasOwnProperty('logo') && detailImages.length > 3) {
      detailImages.splice(3, 0, {});
    } else if (ad && ad.hasOwnProperty('logo') && detailImages.length < 4) {
      detailImages.push({});
    }
    var slides = '';
    if (detail && detailImages && detailImages.length > 0) {
      
      slides = detailImages.map((image, i) => {
        var showAd = false;
        if (_.isEmpty(image)) {
          showAd = true;
        }
        if (ad && !!showAd) {
          return (
            <div key={'ad' + i}>
              <Ad onClick={this.handleAdClick} style={ad.image ? { backgroundImage: 'url(https://s3-us-west-2.amazonaws.com/htb-brc-public/' + ad.image + ')' } : { border: '1px solid #999' }}>
                <AdWrap>
                  {ad.logo ? <AdLogo><img src={'https://s3-us-west-2.amazonaws.com/htb-brc-public/' + ad.logo} /></AdLogo> : null}
                  {ad.headline ? <AdText>{ad.headline}</AdText> : null}
                  {ad.link_text ? <AdButton>{ad.link_text}</AdButton> : null}
                </AdWrap>
              </Ad>
            </div>
          );
        }
        return (
          <SlideWrap key={i}><div className="slide" style={{ backgroundImage: `url(${image.main.filename})` }}>&nbsp;</div></SlideWrap>
        );
      });
    }
    var gradeDate = detail.grade_updated;
    var timeframe = moment().subtract(8, 'days');
    var dryGrade = (detail.dry_grade && moment(gradeDate).endOf('day').isSameOrAfter(timeframe)) ? detail.dry_grade : 'ns';
    var wetGrade = (detail.wet_grade && moment(gradeDate).endOf('day').isSameOrAfter(timeframe)) ? detail.wet_grade : 'ns';
    gradeDate = moment(gradeDate).endOf('day').isSameOrAfter(timeframe) ? moment(gradeDate).endOf('day') : null;

    // console.log('gradeDate: ', gradeDate.fromNow());
    // console.log('chartWidth: ', chartWidth);
    // console.log('chartGradesWidth: ', chartGradesWidth);
    // console.log('chartGradesWidth - chartWidth: ', chartGradesWidth - chartWidth);
    var maxX = chartGradesWidth - chartWidth;
    var customWidth = chartWidth ? chartWidth / numGrades : 50;
    // console.log('maxX: ', maxX);
    return (
      <DetailWrapper>
        <Helmet>
          <title>{detail.name1 ? detail.name1 : detail.title} | Beach Report Card | Heal the Bay</title>
          {detail.description ? <meta property="og:description" name="description" content={detail.description} /> : ''}
          <meta itemprop="image" content={detail.image ? detail.image : process.env.REACT_APP_PUBLIC_URL + "/images/brc_logo.png"} />
          <meta name="twitter:image:src" content={detail.image ? detail.image : process.env.REACT_APP_PUBLIC_URL + "/images/brc_logo_twitter.png"} />
          <meta property="og:image" content={detail.image ? detail.image : process.env.REACT_APP_PUBLIC_URL + "/images/brc_logo.png"} />
        </Helmet>
        <Container data-simplebar>
          <BackLink onClick={this.handleDetailClose}><Icon name="back" /> Back to results</BackLink>
          <Content>
            <Title>{detail.name1 ? detail.name1 : detail.title}</Title>
            <MGrid container spacing={0}>
              <MGrid item xs={12} sm={8} lg={10}>
                <SubTitle>{detail.name2 ? detail.name2 : detail.city}</SubTitle>
              </MGrid>
              <MGrid item xs={12} sm={4} lg={2} className="left-xs right-sm social">
                <span onClick={() => this.openWindow('twitter')}><Icon name="twitter" /></span>
                <span onClick={() => this.openWindow('gplus')}><Icon name="gplus" /></span>
                <span onClick={() => this.openWindow('facebook')}><Icon name="facebook" /></span>
              </MGrid>
            </MGrid>
            <MGrid container spacing={0} justify="space-between">
              <MGrid item xs={12} md={5}>
                {this.renderAlert()}
                {this.renderNowcast()}
                <MGrid container spacing={16} style={{ marginBottom: '9px' }}>
                  <MGrid item xs={6}>
                    <Stat>
                      <MGrid container spacing={16} alignItems="flex-end" justify="space-between">
                        <MGrid className="label" item xs={7}>Dry Grade</MGrid>
                        <MGrid className="date right-lg" item xs={5}>
                          {gradeDate ? <ReactMoment fromNow>{gradeDate}</ReactMoment> : null}
                        </MGrid>
                      </MGrid>
                      <Grade grade={dryGrade} /> <span className="gradeText">{dryGrade}</span>
                    </Stat>
                  </MGrid>
                  <MGrid item xs={6}>
                    <Stat>
                      <MGrid container spacing={16} alignItems="flex-end" justify="space-between">
                        <MGrid className="label" item xs={7}>Wet Grade</MGrid>
                        <MGrid className="date right-lg" item xs={5}>
                          {gradeDate ? <ReactMoment fromNow>{gradeDate}</ReactMoment> : null}
                        </MGrid>
                      </MGrid>
                      <Grade grade={wetGrade} /> <span className="gradeText">{wetGrade}</span>
                    </Stat>
                  </MGrid>
                </MGrid>
                <Description>{detail.description !== 'NULL' ? detail.description : ''}</Description>
              </MGrid>
              <MGrid item xs={12} md={1}></MGrid>
              <MGrid item xs={12} md={6}>
                <Carousel className="carousel">
                  <Slider {...settings}>
                    {slides}
                  </Slider>
                </Carousel>
              </MGrid>
            </MGrid>
            <MGrid container spacing={0}>
              <MGrid item xs={12} md={11} lg={10}>
                {this.renderCountyInfo()}
              </MGrid>
            </MGrid>
            <MGrid container spacing={0}>
              <MGrid item xs={12} md={5}>
                <Historical>
                  <h3>Historical Data</h3>
                  {this.renderAnnuals()}
                </Historical>
              </MGrid>
            </MGrid>
            <MGrid container spacing={0}>
              <MGrid item xs={12}>
                <Historical>
                  {this.renderTabs()}
                  <ChartContainer annual={gType === 'annual' ? 'true' : undefined}>
                    <div id="theChart" onMouseEnter={this.handleMouseTracking} onMouseLeave={this.stopMouseTracking} ref={this.chart}>
                      {gType !== 'annual' ? 
                        <ZoomButtons>
                          <div className={gradeWidth > 15 ? 'icon plus' : 'icon plus disabled'} 
                            onTouchStart={this.handleZoomIn} 
                            onTouchEnd={this.handleStopZoom}
                            onMouseDown={this.handleZoomIn} 
                            onMouseUp={this.handleStopZoom}>+</div>
                          <div className={gradeWidth < 50 ? 'icon minus' : 'icon minus disabled'} 
                            onTouchStart={this.handleZoomOut} 
                            onTouchEnd={this.handleStopZoom}
                            onMouseDown={this.handleZoomOut} 
                            onMouseUp={this.handleStopZoom}>&#8211;</div>
                        </ZoomButtons>
                        : null}
                      {(!chartGradesWidth && gType !== 'annual') ?
                        <ArrowPrev onMouseDown={this.handlePrevArrow} onMouseUp={this.handleStopArrows}>
                          <Icon name="arrowLeft" />
                        </ArrowPrev>
                        : null}
                      {(chartGradesWidth && !!showPrevArrow && chartGradesWidth > 0 && posX < (chartGradesWidth - chartWidth) && gType !== 'annual') ?
                        <ArrowPrev onMouseDown={this.handlePrevArrow} onMouseUp={this.handleStopArrows}>
                          <Icon name="arrowLeft" />
                        </ArrowPrev>
                        : null}
                      {(posX > 0 && gType !== 'annual') ?
                        <ArrowNext onMouseDown={this.handleNextArrow} onMouseUp={this.handleStopArrows}>
                          <Icon name="arrowRight" />
                        </ArrowNext>
                        : null}
                      <Draggable axis="x" 
                        onStop={this.handleStop}
                        disabled={gType === 'annual'}
                        position={{
                          x: posX < 0 ? 0 : (posX > maxX && maxX > 0) ? maxX : posX,
                          y: 0
                        }}>
                        <div onWheel={this.handleKeyEvent} className="gradeItems">
                          {numGrades > 0 ?
                            <Grid
                              ref={this.gridRef}
                              cellRenderer={this._cellRenderer}
                              columnCount={numGrades}
                              columnWidth={gType !== 'annual' ? gradeWidth : customWidth}
                              overscanColumnCount={gType !== 'annual' ? 2000 : 0}
                              height={200}
                              rowCount={1}
                              rowHeight={200}
                              width={chartWidth ? chartWidth : 450}
                              onSectionRendered={this.setChartWidth}
                            />
                            : null}
                        </div>
                      </Draggable>
                    </div>
                  </ChartContainer>
                  {this.renderDateRange()}

                  {gType === 'weekly' ?
                    <Toggle>
                      Dry
                      <Switch
                        checked={!!!dryDefault}
                        onChange={this.handleDryOrWet}
                        value="Dry"
                        classes={{
                          switchBase: classes.iOSSwitchBase,
                          bar: classes.iOSBar,
                          icon: classes.iOSIcon,
                          iconChecked: classes.iOSIconChecked,
                          checked: classes.iOSChecked,
                        }}
                      />
                      Wet
                    </Toggle>
                    : null}
                  {gType === 'annual' ?
                    <RadioGroup
                      row={true}
                      aria-label="Annual"
                      name="annualType"
                      value={annualType}
                      onChange={this.handleTypeSelect}
                    >
                      <FormControlLabel value="summer" control={<Radio color="primary" />} label="Summer Dry" />
                      <FormControlLabel value="winter" control={<Radio color="primary" />} label="Winter Dry" />
                      <FormControlLabel value="wet" control={<Radio color="primary" />} label="Annual Wet" />
                    </RadioGroup>
                    : null}
                </Historical>
                <DataTable screenWidth={wW}>
                  <Table id="dataTable">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          style={{ position: 'sticky', top: 0 }}
                          key="date"
                          sortDirection={sortBy === 'date' ? sortDirection : false}
                        >
                          <TableSortLabel
                            active={sortBy === 'date'}
                            direction={sortDirection}
                            onClick={this._sort('date')}
                          >
                            Date
                          </TableSortLabel>
                        </TableCell>
                        {this.renderHeaderCells()}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.renderTableCells()}
                      {this.renderEmptyRows()}
                    </TableBody>
                  </Table>
                  <TablePagination
                    component="div"
                    count={sortedList.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                      'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                      'aria-label': 'Next Page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                  />
                </DataTable>
              </MGrid>
            </MGrid>
          </Content>
        </Container>
      </DetailWrapper>
    );
  }
}

const styles = theme => ({
  iOSSwitchBase: {
    '&$iOSChecked': {
      '& + $iOSBar': {
        backgroundColor: theme.palette.common.white,
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(18px)'
  },
  iOSBar: {
    borderRadius: 13,
    width: 36,
    height: 17,
    marginTop: '-9px',
    marginLeft: '-16px',
    border: 'solid 1px',
    borderColor: '#0066ff',
    backgroundColor: theme.palette.common.white,
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    backgroundColor: '#0066ff',
    width: 20,
    height: 20,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

const mapStateToProps = state => {
  return {
    detailShown: state.brc.detailShown,
    detail: state.brc.detail,
    wW: state.brc.wW,
    wH: state.brc.wH,
    ad: state.brc.ad,
    router: state.router
  };
};

export default connect(mapStateToProps, { ...Actions })(withStyles(styles)(Detail));


// WEBPACK FOOTER //
// ./src/components/Detail/index.js